import { createAction } from "@reduxjs/toolkit";

export namespace CartActions {
  export namespace Verification {
    export enum ActionTypes {
      updateKYC = "Cart - Verification : Update KYC",
      updateKYB = "Cart - Verification : Update KYB",
      updateIndividualAML = "Cart - Verification : Update Individual AML",
      updateBusinessAML = "Cart - Verification : Update Business AML",
    }

    export const updateKYC = createAction<number, ActionTypes.updateKYC>(
      ActionTypes.updateKYC
    );
    export const updateKYB = createAction<number, ActionTypes.updateKYB>(
      ActionTypes.updateKYB
    );
    export const updateIndividualAML = createAction<
      number,
      ActionTypes.updateIndividualAML
    >(ActionTypes.updateIndividualAML);
    export const updateBusinessAML = createAction<
      number,
      ActionTypes.updateBusinessAML
    >(ActionTypes.updateBusinessAML);

    export type Actions =
      | ReturnType<typeof updateKYC>
      | ReturnType<typeof updateKYB>
      | ReturnType<typeof updateIndividualAML>
      | ReturnType<typeof updateBusinessAML>;
  }
  export namespace Participations {
    export enum ActionTypes {
      updateUser = "Cart - Participations: update Users",
    }

    export const updateUser = createAction<number, ActionTypes.updateUser>(
      ActionTypes.updateUser
    );

    export type Actions = ReturnType<typeof updateUser>;
  }

  export type Actions = Verification.Actions | Participations.Actions;
}
